import { ColumnDef } from '@tanstack/react-table';
import { FaUpRightFromSquare } from 'react-icons/fa6';
import TableCellText from '@/components/atoms/TableCellText';
import ApprovalDetailingTableCell from '@/components/molecules/ApprovalDetailingTableCell';
import { getMotiveText, getStatusText } from '@/utils/extraTripsApprovals';
import { formatddMMyyyy } from '@/utils/formatDate';
import {
	ApprovalFlowStatus,
	ExtraTripsApproval,
	ExtraTripsPeriodDates,
} from '../ApprovalConstants';

export const columns: Array<ColumnDef<ExtraTripsApproval>> = [
	{
		accessorKey: 'extraTripSolicitationId',
		header: '#ID',
		meta: {
			headerClassName: 'pl-3',
		},
		cell: (props) => (
			<div className="w-10 pl-3">
				<TableCellText text={props.getValue() as string} width="full" />
			</div>
		),
	},
	{
		accessorKey: 'employee.name',
		header: 'Colaborador',
		meta: {
			headerClassName: 'pl-3',
		},
		cell: (props) => (
			<div className="w-40 pl-3">
				<TableCellText text={props.getValue() as string} width="full" />
			</div>
		),
	},
	{
		accessorKey: 'employee.structure',
		header: 'Estrutura',
		meta: {
			headerClassName: 'pl-3',
		},
		cell: (props) => {
			const value = (props.getValue() as string) ?? '-';
			return (
				<div className="w-[7rem] pl-3">
					<TableCellText text={value} width="full" />
				</div>
			);
		},
	},
	{
		accessorKey: 'employee.employeeNumber',
		header: 'Chapa',
		meta: {
			headerClassName: 'pl-3',
		},
		cell: (props) => (
			<div className="w-[6rem] pl-3">
				<TableCellText text={props.getValue() as string} width="full" />
			</div>
		),
	},
	{
		accessorKey: 'employee.management',
		header: 'Gerência',
		meta: {
			headerClassName: 'pl-3',
		},
		cell: (props) => {
			const value = (props.getValue() as string) ?? '-';
			return (
				<div className="w-40 pl-3">
					<TableCellText text={value} width="full" />
				</div>
			);
		},
	},
	{
		accessorKey: 'workStations',
		header: 'Locais',
		meta: {
			headerClassName: 'pl-3',
		},
		enableSorting: false,
		cell: (props) => {
			const values = props.getValue() as string[];
			const text = values.join(', ');

			return (
				<div className="w-40 pl-3">
					<TableCellText text={text} width="full" />
				</div>
			);
		},
	},
	{
		accessorKey: 'dates',
		header: 'Datas',
		meta: {
			headerClassName: 'pl-3',
		},
		enableSorting: false,
		cell: (props) => {
			const values = props.getValue() as ExtraTripsPeriodDates[];
			const text = values
				.map((date) => {
					if (date.startDate === date.endDate)
						return formatddMMyyyy(date.startDate);

					return `${formatddMMyyyy(date.startDate)} a ${formatddMMyyyy(date.endDate)}`;
				})
				.join(', ');

			return (
				<div className="w-40 pl-3">
					<TableCellText text={text} width="full" />
				</div>
			);
		},
	},
	{
		accessorKey: 'reason',
		header: 'Motivo',
		meta: {
			headerClassName: 'pl-3',
		},
		cell: (props) => (
			<div className="w-40 pl-3">
				<TableCellText
					text={getMotiveText(props.getValue() as string)}
					width="full"
				/>
			</div>
		),
	},
	{
		accessorKey: 'detailing',
		header: 'Detalhamento',
		meta: {
			headerClassName: 'pl-3',
		},
		cell: (props) => {
			const text = (props.getValue() as string) ?? '-';

			return (
				<div className="w-[15rem] pl-3">
					<ApprovalDetailingTableCell text={text} />
				</div>
			);
		},
	},
	{
		accessorKey: '#',
		header: 'Visualizar',
		meta: {
			headerClassName: 'pl-3',
		},
		enableSorting: false,
		cell: (props) => {
			const extraTripSolicitationId =
				props.row.original.extraTripSolicitationId;
			const employeeId = props.row.original.employee.id;

			return (
				<div className="w-20 pl-3">
					<a
						className="flex items-center justify-center"
						title="Visualizar"
						href={`/home/colaborador/${employeeId}/idas-extras/${extraTripSolicitationId}`}
						target="_blank"
					>
						<FaUpRightFromSquare className="text-primary" size={20} />
					</a>
				</div>
			);
		},
	},
	{
		accessorKey: 'status',
		header: 'Status',
		meta: {
			headerClassName: 'pl-3',
		},
		cell: (props) => (
			<div className="w-32 pl-3">
				<TableCellText
					text={getStatusText(props.getValue() as ApprovalFlowStatus)}
					width="full"
				/>
			</div>
		),
	},
];
